import { StyleMixins } from '@atlassian/mpac-utils';
export var ANALYTICS_SUBJECT_ID_VENDOR_NAME = 'vendorName';
export var ANALYTICS_SUBJECT_ID_RATINGS = 'ratings';
/**
 * AppHeader breakpoint for displaying the mobile version, used as:-
 * - with min width: `@media (min-width: ${APP_HEADER_MOBILE_BREAKPOINT}px) { ... }`
 * - with max width: `@media (max-width: ${APP_HEADER_MOBILE_BREAKPOINT-1}px) { ... }`
 **/

export var APP_HEADER_MOBILE_BREAKPOINT = StyleMixins.breakpoints.sm;